//@flow
//@flow
import ptBR from 'date-fns/locale/pt-BR';
import { Formik } from 'formik';
import _ from 'lodash';
import 'moment/locale/pt-br';
import moment from 'moment';
import * as React from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { registerLocale } from 'react-datepicker';
import connect from 'react-redux/es/connect/connect';
import * as Yup from 'yup';
import {
  objectsConstants,
  objectsEnuns,
} from '../../../_constants/objects.constants';
import { dateHelper } from '../../../_helpers/date.helper';
import { translate } from '../../../_helpers/messages.helper';
import { defaultService } from '../../../_services/defaultService';
import { pacienteService } from '../../../_services/paciente.service';
import { saidaEstoqueService } from '../../../_services/saidaEstoque.service';
import { FormGroup } from '../../../components/FormGroup';
import DatePickerInput from '../../../components/inputs/DatePickerInput';
import FormInput from '../../../components/inputs/FormInput';
import InputViewEdit from '../../../components/inputs/InputViewEdit';
import SelectInput from '../../../components/inputs/SelectInput';
import ProdutosSaidaSumario from './ProdutosSaidaSumario';
import ProdutoSaida from './produtoSaida/produtoSaida';
import { tableHelper } from '../../../_helpers/tableHelper';
import { legendHelper } from '../../../_helpers/legend.helper';
import DateTimePicker from '../../../components/inputs/DateTimePicker';

type Props = {
  match: any,
  nome?: string,
  callbackOnSave?: any,
};

type State = {
  id?: number,
};
const OBRIGATORIO = 'Obrigatório';
const hoje = new Date();
const amanha = hoje.setDate(hoje.getDate() + 1);
const STRING_REQUIRED = Yup.string().required(OBRIGATORIO);
const EstoqueSaidaValidate = Yup.object().shape({
  tipoSaida: STRING_REQUIRED,
  dataHoraLancamento: Yup.date()
    .required('Data de lançamento obrigatória')
    .max(new Date(amanha), 'A data inserida não deve ser maior que hoje.'),
  paciente: Yup.string().when('tipoSaida', {
    is: objectsConstants.TIPO_VENDA,
    then: STRING_REQUIRED,
  }),
  justificativa: STRING_REQUIRED,
  listSaidaEstoqueProduto: Yup.array()
    .min(1, 'É necessario informar pelo menos um produto')
    .of(
      Yup.object().shape({
        produto: STRING_REQUIRED,
        lote: Yup.object().shape({
          nome: STRING_REQUIRED,
        }),
        estoqueUnidade: Yup.object().shape({
          id: STRING_REQUIRED,
        }),
        precoUnitario: STRING_REQUIRED,
        quantidade: STRING_REQUIRED,
      })
    ),
});

class EstoqueSaidaForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  goToViewEntity = (values) => {
    const { redirectPath } = this.props;
    this.props.history.push({
      pathname: redirectPath + values.id,
      state: { entity: values },
    });
  };

  addProdutoSaida = (
    propName,
    defaultValue,
    values,
    setValues,
    createAttribute?: boolean
  ) => {
    let newValues = _.cloneDeep(values);
    if (newValues[propName]) {
      newValues[propName].unshift(
        defaultValue
          ? defaultValue
          : { idList: new Date().getTime(), type: '1', fracao: null }
      );
      setValues(newValues);
    }
    if (!newValues[propName] && createAttribute) {
      _.set(newValues, `${propName}`, [
        { idList: new Date().getTime(), type: '1', fracao: null },
      ]);
      setValues(newValues);
    }
  };

  removeProdutoSaida = (propName, indexItem, values, setValues) => {
    let newValues = _.cloneDeep(values);
    if (newValues[propName].length >= 1) {
      newValues[propName].splice(indexItem, 1);
      setValues(newValues);
    }
  };

  saveForm = () => {
    let _this = this;
    let values = _this.formRef.state.values;
    let newValues = _.cloneDeep(values);
    let promise = new Promise(function (resolve) {
      if (values.tipoSaida == objectsConstants.TIPO_VENDA) {
        _.set(newValues, 'type', 0);
      } else {
        _.set(newValues, 'type', 1);
      }
      _this.formRef.validateForm(newValues).then((error) => {
        if (_.isEmpty(error)) {
          const horaLancamento = _.get(values, 'horaLancamento');
          let horarios = horaLancamento.split(':');
          let dt = _.get(values, `dataHoraLancamento`);
          let date = new Date(dt);
          date.setHours(horarios[0]);
          date.setMinutes(horarios[1]);
          _.set(
            newValues,
            'dataHoraLancamento',
            moment(date).format('YYYY-MM-DD HH:mm:ss')
          );
          _this.props.loading(true);
          saidaEstoqueService.doSave(newValues).then(
            (response) => {
              _this.props.success({
                message: `Saída, foi ${!values.id ? 'criado' : 'alterado'
                  } com sucesso!`,
              });
              let id = values.id
                ? values.id
                : defaultService.getIdFromUrl(response.headers.location);
              values.id = id;
              _this.props.loading(false);
              _this.goToViewEntity(values);
              if (_this.props.user.id === values.id) {
                values.role = _this.props.user.role;
                _this.props.refreshUser(values);
              }
              resolve(true);
            },
            (erros) => {
              _this.props.loading(false);

              try {
                let response = erros.response.data;
                if (response && response.message) {
                  _this.props.error({ message: response.message });
                }
              } catch (error) {
                console.log(error);
              }
              console.log(erros);
            }
          );
        } else {
          console.log(error);
          resolve(false);
        }
      });
    });
    return promise;
  };

  resetForm = (initialValues) => {
    this.formRef.resetForm(initialValues);
  };

  componentDidMount() {
    registerLocale('pt-BR', ptBR);
  }


  render() {
    let _this = this;
    const { viewMode, entity, propName, index } = this.props;
    return (
      <React.Fragment>
        <Formik
          validationSchema={EstoqueSaidaValidate}
          validateOnBlur={false}
          validateOnChange={false}
          enableReinitialize={true}
          initialValues={entity}
          ref={(form) => {
            this.formRef = form;
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            validationSchema,
            validateForm,
            setValues,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="form-inside">
                <div className="row section-form">
                  <FormGroup className="col-12 col-xl-2">
                    <InputViewEdit
                      component={SelectInput}
                      options={objectsEnuns.TIPO_SAIDA_NOTA_FISCAL}
                      type="text"
                      name="tipoSaida"
                      label="Tipo de saída"
                      placeholder="Selecione "
                      onChange={(name, value) => {
                        setFieldValue(name, value);
                      }}
                      noSize={true}
                      viewMode={viewMode || values.id}
                      id="tipoSaida"
                      returnFullObject={false}
                      labelKey={'label'}
                      valueKey={'value'}
                      multi={false}
                      value={values.tipoSaida}
                      erroMensagem={errors.tipoSaida}
                      required={true}
                      defaultValue={
                        _.get(values, 'tipoSaida')
                          ? legendHelper.isTipoSaida(_.get(values, 'tipoSaida'))
                          : '--'
                      }
                    />
                    {/* {viewMode && (
                      <>
                        <label>Tipo de saída</label>
                        <p className="ml-1">
                          {values.type == '0' ? 'NOTA FISCAL' : 'MANUAL'}
                        </p>
                      </>
                    )} */}
                  </FormGroup>
                  {values.id && (
                    <FormGroup className="col-12 col-xl-2">
                      <InputViewEdit
                        component={SelectInput}
                        options={objectsEnuns.SITUACAO_SAIDA_ESTOQUE}
                        type="text"
                        name="situacao"
                        label="Situação"
                        placeholder="Selecione "
                        onChange={(name, value) => {
                          setFieldValue(name, value);
                        }}
                        noSize={true}
                        viewMode={viewMode}
                        id="situacao"
                        returnFullObject={false}
                        labelKey={'label'}
                        valueKey={'value'}
                        multi={false}
                        value={values.situacao}
                        erroMensagem={_.get(errors, 'situacao')}
                        required={true}
                        defaultValue={_.get(values, 'situacao')}
                      />
                    </FormGroup>
                  )}
                </div>
                {_.get(values, 'tipoSaida') && (
                  <>
                    <div className="row section-form">
                      <FormGroup className="col-12 col-xl-3">
                        <InputViewEdit
                          component={DatePickerInput}
                          label={'Data e hora do lançamento'}
                          type="text"
                          id="dataHoraLancamento"
                          name="dataHoraLancamento"
                          placeholder=""
                          value={values.dataHoraLancamento}
                          onChange={(name, value) => setFieldValue(name, value)}
                          noSize={true}
                          erroMensagem={_.get(errors, 'dataHoraLancamento')}
                          viewMode={viewMode}
                          required={true}
                          viewClassName={'font-weight-bold'}
                          defaultValue={
                            _.get(values, `dataHoraLancamento`)
                              ? dateHelper.format(
                                _.get(values, `dataHoraLancamento`),
                                {
                                  mode: 'DATE',
                                }
                              )
                              : '--'
                          }
                        />
                      </FormGroup>
                      <FormGroup className="col-12 col-xl-2">
                        <InputViewEdit
                          label="Hora do lançamento"
                          format={'HH:mm'}
                          component={DateTimePicker}
                          defaultValue={
                            _.get(values, `horaLancamento`)
                              ? _.get(values, `horaLancamento`)
                              : '--'
                          }
                          name={`horaLancamento`}
                          id={`horaLancamento`}
                          erroMensagem={_.get(errors, `dataHoraLancamento`)}
                          value={values.horaLancamento}
                          onChange={setFieldValue}
                          showTimeSelect={true}
                          showTimeSelectOnly={true}
                          placeholder={'--:--'}
                          timeIntervals={30}
                          viewMode={viewMode}
                          defaultValue={
                            _.get(values, `horaLancamento`)
                              ? _.get(values, `horaLancamento`)
                              : '--'
                          }
                          required
                        />
                      </FormGroup>

                      {_.get(values, 'tipoSaida') &&
                        values.tipoSaida == objectsConstants.TIPO_VENDA && (
                          <FormGroup className="col-12 col-xl-3">
                            <InputViewEdit
                              component={SelectInput}
                              id="paciente"
                              name="paciente"
                              label="Paciente"
                              onFetchData={pacienteService.findByNomeOuCPF}
                              onChange={(name, value) =>
                                setFieldValue(name, value)
                              }
                              noSize={true}
                              erroMensagem={_.get(errors, 'paciente')}
                              value={values.paciente}
                              labelKey="nome"
                              multi={false}
                              returnFullObject={true}
                              creatable={false}
                              viewMode={viewMode}
                              required
                              placeholder="Digite e selecione um paciente"
                              defaultValue={
                                _.get(values, 'paciente')
                                  ? _.get(values, 'paciente').nome
                                  : '--'
                              }
                            />
                          </FormGroup>
                        )}
                    </div>

                    <div className="row section-form">
                      <FormGroup className="col-12 col-xl-10">
                        <InputViewEdit
                          component={FormInput}
                          label={'Justificativa'}
                          type="text"
                          id="justificativa"
                          defaultValue={_.get(values, 'justificativa')}
                          name="justificativa"
                          placeholder="Informe uma justificativa"
                          value={values.justificativa}
                          onChange={(name, value) => setFieldValue(name, value)}
                          noSize={true}
                          viewMode={viewMode}
                          erroMensagem={_.get(errors, 'justificativa')}
                          required={true}
                        />
                      </FormGroup>
                    </div>

                    <div className="d-flex align-items-center justify-content-center">
                      <ProdutosSaidaSumario entity={values} />
                    </div>
                    {/* <h1 className="w-100">Unidades fração</h1> */}

                    <div
                      className={`form-row justify-content-md-start justify-content-center pl-10px ${viewMode ? 'd-none' : ''
                        }`}
                    >
                      <button
                        onClick={() =>
                          this.addProdutoSaida(
                            'listSaidaEstoqueProduto',
                            null,
                            values,
                            setValues,
                            true
                          )
                        }
                        type="button"
                        className="btn btn-primary"
                      >
                        Adicionar novo produto
                      </button>
                    </div>

                    {values.listSaidaEstoqueProduto &&
                      values.listSaidaEstoqueProduto.map((produto, index) => {
                        return (
                          <div className="row section-form" key={index}>
                            <ProdutoSaida
                              entity={values}
                              index={index}
                              viewMode={viewMode}
                              size={values.listSaidaEstoqueProduto.length}
                              handleChange={handleChange}
                              errors={errors}
                              propName={`listSaidaEstoqueProduto[${index}]`}
                              onChange={(name, value) => {
                                setFieldValue(name, value);
                              }}
                              removeItem={() => {
                                this.removeProdutoSaida(
                                  `listSaidaEstoqueProduto`,
                                  index,
                                  values,
                                  setValues
                                );
                              }}
                            ></ProdutoSaida>
                          </div>
                        );
                      })}
                    {values.listSaidaEstoqueProduto &&
                      values.listSaidaEstoqueProduto.length < 1 && (
                        <div className="d-flex align-items-center justify-content-center txt-red">
                          <p>É necessário informar ao menos um produto!</p>
                        </div>
                      )}
                  </>
                )}
              </div>
            </form>
          )}
        </Formik>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  };
}

const mapDispatch = ({
  alert: { success, error, clear },
  load: { loading },
  authentication: { refreshUser },
}) => ({
  refreshUser: (user) => refreshUser({ user }),

  success: (msg) => success(msg),
  loading: (load: boolean) => loading({ load }),
  error: (msg) => error(msg),
  clear: () => clear(),
});

export default connect(mapStateToProps, mapDispatch, null, {
  forwardRef: true,
})(EstoqueSaidaForm);
